import admin from './view';

export default [
  {
    path: '/',
    component: admin('/dummy'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/statistic.js